import axiosInstance from "../axios/axios-configuration";
import { CancelToken } from "axios";
import { IAoo } from "../shared/interfaces";

const controller = 'Aoos';

const get = (id, cancelToken?: CancelToken): Promise<IAoo> => {
    return axiosInstance.get(`${controller}/${id}`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getActiveAooForCurrentUser = (cancelToken ?: CancelToken): Promise<IAoo[]> => {
    return axiosInstance.get(`${controller}/GetActiveAooForCurrentUser`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

export default {
    get,
    getActiveAooForCurrentUser
}